(function (app) {
    app.provider("reviewQueueApi", [function () {

        this.$get = ["complianceHubApiGateway", function (complianceHubApiGateway) {
            var service = {};

            // GETs

            service.getAllFirelightApplication = function (queueId) {
                return complianceHubApiGateway.getArray("/ReviewQueue/Queue/" + queueId).then(function (apps) {
                    return apps;
                });
            };
            service.getFirelightListDocuments = function (firelightApplicationId) {
                return complianceHubApiGateway.getArray("/ReviewQueue/" + firelightApplicationId).then(function (files) {
                    return files;
                });
            };
            service.getFirelightApplicationDocument = function (firelightApplication, document) {
                return "/ReviewQueue/Queue/" + firelightApplication.TransactionId + "/FileName/" + document.FileName;
            };

            // PUTs

            service.updateReviewQueueState = function(queueEntry) {
                return complianceHubApiGateway.put("/ReviewQueue/QueueEntry/" + queueEntry.QueueEntryId, queueEntry);
            }

            return service;
        }];

    }]);

})(window.app);